//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState } from 'vuex'
import footerLinks from '~/components/common/footerLinks.vue'
import mobileBottom from '~/components/common/mobileBottom.vue'
// import nationList from '~/static/json/countryList.json'
import riskWarning from '~/components/common/riskWarning.vue'
export default {
  components: {
    'mobile-bottom': mobileBottom,
    'risk-warning': riskWarning,
    'footer-links': footerLinks
  },
  data () {
    return {
      // linkDom: '', // 外链dom
      isHover: false, // 鼠标是否移入选择国家
      mySearch: '', // 用户输入的国家
      // 底部
      countryList: this.$store.state.footCountry, // 弹框国家列表
      showMNation: true, // 是否展示国家列表弹框（移动端）
      searchcounryList: [] // 搜索到的国家
    }
  },
  computed: {
    ...mapState({
      linkDom: 'linkDom'
    }),
    // 本项目logo
    fxLogo () {
      const selectedLang = this.currLangCode()
      if (selectedLang == 'zh-cn') return 'https://resources.interface003.com/web20/img/home/logo-cn.svg'
      else if (['zh-tw', 'zh-hk', 'zh'].includes(selectedLang)) return 'https://resources.interface003.com/web20/img/home/logo-tw.svg'
      else return 'https://resources.interface003.com/web20/img/home/logo-en.svg'
    },
    // 用户IP定位的国家信息
    myCountryInfo () {
      const { flag = '', name = '', countryCode: code = '', twoCharCode = '' } = this.getMyCountry({ twoCharCode: this.userCountry()?.toUpperCase() }) || {}
      return { flag, name, code, twoCharCode }
    },
    // 用户选择的国家是否和IP定位的国家一致
    isMyNation () {
      const { CountryCode = 'us', myCountry = 'us' } = this.$store.state
      return CountryCode != myCountry
    }
  },
  created () {
    if (process.client) return
    // 处理外链dom
    const selectedLang = this.currLangCode()
    const linkList = [
      { name: '关于我们', url: `https://www.${this.$store.state.newhost}.${this.$store.state.suffix}/${selectedLang}/about.html` },
      { name: '联系我们', url: `https://www.${this.$store.state.newhost}.${this.$store.state.suffix}/${selectedLang}/contract.html` },
      { name: '风险提示', url: 'javascript:;' },
      { name: '使用条款', url: `https://www.${this.$store.state.newhost}.${this.$store.state.suffix}/${selectedLang}/terms.html?type=1` },
      { name: '隐私声明', url: `https://www.${this.$store.state.newhost}.${this.$store.state.suffix}/${selectedLang}/terms.html?type=3` },
      { name: '搜索调用', url: `https://www.${this.$store.state.newhost}.${this.$store.state.suffix}/${selectedLang}/TraderSearch_Open.html` },
      { name: '企业版(天眼号)', url: 'https://www.wikiltd.com' },
      { name: '官方验证', url: `//v.${this.$store.state.newhost}.${this.$store.state.suffix}/${selectedLang}` },
      { name: '展会', url: `//www.wikiexpo.com/${selectedLang}/` },
      { name: '天眼研究院', url: `//www.wikiresearch.com/${selectedLang}/` }
    ]
    let str = ''
    linkList.forEach((item, index) => {
      if (index == 2) {
        str += `<a href="${item.url}" onclick="test()" class="single-link">${this.$v(item.name)}</a><i class="segment">|</i>`
      } else {
        str += `<a href="${item.url}" target="_blank" class="single-link">${this.$v(item.name)}</a><i class="segment">|</i>`
      }
    })
    this.$store.commit('setlinkDom', str)
  },
  mounted () {
    window.test = (event) => {
      this.$refs.riskWarning.dialogVisible = true
    }
    document.addEventListener('click', () => {
      this.showMNation = true
    }, { passive: true })
  },
  methods: {
    // 更换国家
    countryFn (obj = {}, type = 1) {
      const { host: hostS = '' } = this.$store.state
      const abbr = type == 1 ? (obj?.abbr) : (obj?.twoCharCode.toLowerCase())
      this.$store.commit('setCountryCode', { country: abbr, hostS })
      const arr = [
        {
          lang: 'ja',
          country: 'jp'
        },
        {
          lang: 'vi',
          country: 'vn'
        },
        {
          lang: 'th',
          country: 'th'
        },
        {
          lang: 'id',
          country: 'id'
        },
        {
          lang: 'zh',
          country: 'hk'
        },
        {
          lang: 'zh',
          country: 'tw'
        },
        {
          lang: 'es',
          country: 'es'
        },
        {
          lang: 'en',
          country: 'au'
        },
        {
          lang: 'de',
          country: 'de'
        },
        {
          lang: 'en',
          country: 'uk'
        },
        {
          lang: 'en',
          country: 'us'
        },
        {
          lang: 'zh-cn',
          country: 'cn'
        },
        {
          lang: 'ar',
          country: 'ae'
        },
        {
          lang: 'ru',
          country: 'ru'
        },
        {
          lang: 'fil',
          country: 'ph'
        },
        {
          lang: 'hi',
          country: 'in'
        },
        {
          lang: 'fr',
          country: 'fr'
        },
        {
          lang: 'tr',
          country: 'tr'
        },
        {
          lang: 'pt',
          country: 'pt'
        },
        {
          lang: 'ko',
          country: 'kr'
        }
      ]
      const tabcontry = arr.filter(item => item.country == abbr)
      console.log('tabcontry: ', tabcontry)
      if (tabcontry && tabcontry[0] && tabcontry[0].lang) {
        const url = window.location.pathname.split('/').slice(2).join('/')
        window.location.href = `/${tabcontry[0].lang}/${url}`
        return
      }
      this.$nextTick(() => {
        location.reload(true)
      }) // 页面刷新
    },
    searchCountry () { // 搜索国家
      if (!this.mySearch) return
      this.$api.home.countrysearch({ content: this.mySearch }).then((res) => {
        this.searchcounryList = [...res]
      })
    },
    leaveCountry () {
      this.mySearch = ''
      this.searchcounryList = []
      this.isHover = false
    }
  }
}
